import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';

import {
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrPrintPageModule,
  AgrSummaryCardModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';

import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { CreateFeedAdviceComponent } from './components/create-feed-advice/create-feed-advice.component';
import { CreateFeedAdviceFromReferenceComponent } from './components/create-feed-advice-from-reference/create-feed-advice-from-reference.component';
import { FeedAdviceOverviewComponent } from './components/feed-advice-overview/feed-advice-overview.component';
import { FeedAdviceReportComponent } from './components/feed-advice-report/feed-advice-report.component';
import { FeedAdviceRouterComponent } from './components/feed-advice-router/feed-advice-router.component';
import { FeedAdviceOverviewResolver } from './resolvers/feed-advice-overview.resolver';
import { GetFeedAdviceByIdResolver } from './resolvers/get-feed-advice-by-id.resolver';
import { FeedAdviceService } from './services/feed-advice.service';

import { FeedAdviceEffects } from './store/feed-advice.effects';
import * as feedAdviceReducer from './store/feed-advice.reducer';

@NgModule({
  declarations: [
    CreateFeedAdviceComponent,
    CreateFeedAdviceFromReferenceComponent,
    FeedAdviceOverviewComponent,
    FeedAdviceReportComponent,
    FeedAdviceRouterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgrPageToolbarModule,
    AgrTableModule,
    MatSlideToggleModule,
    MatButtonModule,
    AgrDialogModule,
    AgrPageDetailModule,
    AgrFormModule,
    MatFormFieldModule,
    MatInputModule,
    AgrSummaryCardModule,
    MatSelectModule,
    MatListModule,
    MatIconModule,
    AgrPrintPageModule,
    MatAutocompleteModule,
    RouterModule,
  ],
  providers: [
    FeedAdviceService,
    FeedAdviceOverviewResolver,
    GetFeedAdviceByIdResolver,
    provideState('feedAdviceModule', feedAdviceReducer.reducer),
    provideEffects([FeedAdviceEffects]),
  ],
})
export class FeedAdviceModule {}
